<template>
  <core-main class="py-12">
    <template v-slot:toolbar-title>
      {{ $t('form.settings.name') }}
    </template>

    <template #extension>
      <v-tabs
        v-model="selectedSettingsTab"
        horizontal
        class="fill-height"
      >
        <core-tab text="Company" icon="mdi-domain" />
        <core-tab text="Users" icon="mdi-account-outline" />
        <core-tab text="Roles" icon="mdi-account-cog-outline" />
        <core-tab text="Forwarders" icon="mdi-truck" />
      </v-tabs>
    </template>

    <v-container class="px-0" fluid>
      <v-row justify="center" style="height: 100%;">
        <v-col cols="12">
          <v-tabs-items v-model="selectedSettingsTab">
            <v-tab-item>
              <core-company-settings />
            </v-tab-item>
            <v-tab-item>
              <core-user-settings />
            </v-tab-item>
            <v-tab-item>
              <core-role-settings />
            </v-tab-item>
            <v-tab-item>
              <v-container>
                <core-no-content />
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </core-main>
</template>

<script>
export default {
  name: 'Settings',

  data() {
    return {
      selectedSettingsTab: 0,
    };
  },
};
</script>

<style scoped>
  .theme--light.v-tabs-items {
    background-color: transparent;
  }
</style>
